<template>
    <div class="d-flex flex-column">
        <b-table head-variant="light" bordered :items="items" :fields="fields" :busy="carregando" show-empty responsive style="max-height: 90vh !important;">
			<template #empty >
                	<div class="d-flex">
                    	<span class="mx-auto">
                        	Nenhum Registro Encontrado
                    	</span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
				<template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
				<template #cell(situacao)="data">
					<div class="d-flex gap-sm align-items-center">
						<span>
							<font-awesome-icon :icon="['fas', 'circle']" :class="selecionaCorSituacaoAgendamento(data.item.situacao)" />
						</span>
						<span>{{ data.item.situacao }}</span>
					</div>
				</template>
				<template #cell(acao)="data">
					<span style="cursor: pointer;" class="p-1" @click="abrirModalGerenciarSolicitacao(data.item.id)">
						<font-awesome-icon :icon="['fas', 'magnifying-glass']" style="font-size: 22px;"/>
					</span>
					<modalGerenciarSolicitacaoAgendamento @agendamentoCancelado="handleAgendamentoCancelado" @agendamentoRealizado="handleAgendamentoRealizado" :agendamento="data.item"/>
				</template>
		</b-table>
		<span>Total: {{ numeroTotalSolicitacoes }}</span>
        <b-pagination class="mx-auto" @input="consultarAgendamentos" v-model="paginaAtualSolicitacoes" :total-rows="numeroTotalSolicitacoes" :per-page="numeroDeSolicitacoesPorPagina"></b-pagination>
    </div>
</template>

<script>
import AgendamentoService from "../../service/AgendamentoService.js";
import ModalGerenciarSolicitacaoAgendamento from "./ModalGerenciarSolicitacaoAgendamento.vue";

export default{
	name: "Solicitacoes",
	components: {
		modalGerenciarSolicitacaoAgendamento: ModalGerenciarSolicitacaoAgendamento,
	},
	data() {
		return {
			carregando: false,
			items: [],
			fields: [
				{
					key: "index",
					label: "#",
				},
				{
					key: "solicitante",
					label: "Solicitante",
				},
				{
					key: "funcionario",
					label: "Funcionário",
				},
				{
					key: "periodo",
					label: "Período",
				},
				{
					key: "exame",
					label: "Exame",
				},
				{
					key: "dataInicio",
					label: "Data do Pedido de Agendamento",
				},
				{
					key: "situacao",
					label: "Situação",
				},
				{
					key: "acao",
					label: "",
				},
			],
			numeroTotalSolicitacoes: 0,
			numeroDeSolicitacoesPorPagina: 10,
			paginaAtualSolicitacoes: 1,

			classSituacao: "",
		};
	},
	created() {
		this.filtrarAgendamentos();
	},
	methods: {
		handleAgendamentoCancelado() {
			this.mensagem("Agendamento Cancelado Com Sucesso!", "Sucesso", "success");
			this.filtrarAgendamentos();
		},
		handleAgendamentoRealizado() {
			this.mensagem("Agendamento Realizado Com Sucesso!", "Sucesso", "success");
			this.filtrarAgendamentos();
		},
		abrirModalGerenciarSolicitacao(id) {
			this.$bvModal.show("modal-gerenciar-solicitacao-agendamento-" + id);
		},
		filtrarAgendamentos() {
			this.paginaAtualSolicitacoes = 1;
			this.consultarAgendamentos();
		},
		consultarAgendamentos() {
			this.carregando = true;
			AgendamentoService.consultar(this.paginaAtualSolicitacoes - 1, this.numeroDeSolicitacoesPorPagina)
				.then((res) => {
					this.items = res.data[0];
					this.numeroTotalSolicitacoes = res.data[1];
				}).catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível realizar a consulta dos agendamentos", "Erro", "danger");
					}
				}).finally(() => {
					this.carregando = false;
				});
		},
		selecionaCorSituacaoAgendamento(situacao) {
			switch (situacao) {
			case "Agendado":
				return "statusAgendado";
			case "Aguardando":
				return "statusAguardando";

			case "Cancelado":
				return "statusCancelado";
			default:
				return "";
			}
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};


</script>

<style>
.statusAgendado{
	color: rgb(82, 172, 41) !important;
}

.statusAguardando{
	color: rgb(233, 188, 63) !important;

}
.statusCancelado{
	color: rgb(172, 41, 41) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Agendamento/Solicitacoes.vue